const setGridMetadata = gridWidth => dispatch =>
  dispatch({
    type: 'GRID_INITIALIZED',
    payload: {
      gridWidth
    }
  })

export default setGridMetadata